import { ISwarmEventResponse, ISwarmGameResponse, ISwarmMarketResponse, ISwarmSportResponse, SwarmResponse } from "./models/response";

export interface ISwarmDestructureResult {
    game: ISwarmGameResponse;
    event: ISwarmEventResponse;
    market: ISwarmMarketResponse;
    sport: ISwarmSportResponse;
};

export type SwarmGameEvent = Pick<ISwarmDestructureResult, 'game' | 'event'>;
export type SwarmGameMarketEvent = Pick<ISwarmDestructureResult, 'game' | 'market' | 'event'>;
export type SwarmMarketEvent = Pick<ISwarmDestructureResult, 'market' | 'event'>;

export const getEventsFromGame = (data: SwarmResponse<ISwarmGameResponse>) => (
    Object.values(data).reduce((acc: SwarmGameMarketEvent[], game) => {

        Object.values(game.market).map(market => {

            Object.values(market.event).map(event => {
                acc.push({ event, market, game });
            });
        })

        return acc;
    }, [])
);

export const getEventsFromMarket = (data: SwarmResponse<ISwarmMarketResponse>) => (
    Object.values(data).reduce((acc: SwarmMarketEvent[], market) => {

        Object.values(market.event).forEach(event => {
            acc.push({ event, market });
        });

        return acc;
    }, [])
);